import React from "react";

// Affichage en consultation des médias normalisés (ADR 0005) d'un type
// donné. Les POI créés après la migration peuvent n'exposer QUE
// `marker.media` : ce composant ne dépend d'aucun champ legacy.
// Le libellé de section est porté par le conteneur
// (RessourceTouristicMarker) : ce composant n'en rend aucun, sinon le
// même média produit deux sections homonymes (C2, parcours 2026-09-04).
const ServerMediaList = ({ marker, mediaType }) => {
  const mediaEntries = (marker.media || []).filter(
    (media) => media.mediaType === mediaType && media.url
  );
  if (mediaEntries.length === 0) {
    return null;
  }

  return (
    <div className="m-4" data-testid={`server-media-${mediaType}`}>
      {mediaEntries.map((media) => (
        <div key={media.fileName} className="mb-3">
          <div>{media.originalName || media.fileName}</div>
          {mediaType === "image" && (
            <img
              alt={media.originalName || media.fileName}
              src={media.url}
              className="imageMarker"
            />
          )}
          {mediaType === "video" && (
            <video controls className="videoInput">
              <source src={media.url} type={media.mimeType || "video/mp4"} />
            </video>
          )}
          {mediaType === "audio" && (
            <audio controls className="audioInput">
              <source src={media.url} type={media.mimeType || "audio/mpeg"} />
            </audio>
          )}
        </div>
      ))}
    </div>
  );
};

export default ServerMediaList;
